export default function getSpecialChars() {
  let specialChars = [
    {
      id: 1,
      name: 'A WITH ACUTE, UPPERCASE',
      unicode: 'U+00C1',
      symbol: '&Aacute;',
      char: 'Á',
      type: 'uppercase'
    },
    {
      id: 2,
      name: 'E WITH ACUTE, UPPERCASE',
      unicode: 'U+00C9',
      symbol: '&Eacute;',
      char: 'É',
      type: 'uppercase'
    },
    {
      id: 3,
      name: 'I WITH ACUTE, UPPERCASE',
      unicode: 'U+00D3',
      symbol: '&Iacute;',
      char: 'Í',
      type: 'uppercase'
    },
    {
      id: 4,
      name: 'O WITH ACUTE, UPPERCASE',
      unicode: 'U+00F3',
      symbol: '&Oacute;',
      char: 'Ó',
      type: 'uppercase'
    },
    {
      id: 5,
      name: 'U WITH ACUTE, UPPERCASE',
      unicode: 'U+00DA',
      symbol: '&Uacute;',
      char: 'Ú',
      type: 'uppercase'
    },
    {
      id: 6,
      name: 'U WITH DIAERESIS, UPPERCASE',
      unicode: 'U+00DC',
      symbol: '&Uuml;',
      char: 'Ü',
      type: 'uppercase'
    },
    {
      id: 7,
      name: 'N WITH TILDE, UPPERCASE',
      unicode: 'U+00D1',
      symbol: '&Ntilde;',
      char: 'Ñ',
      type: 'uppercase'
    },

    {
      id: 8,
      name: 'A WITH ACUTE, LOWERCASE',
      unicode: 'U+00E1',
      symbol: '&aacute;',
      char: 'á',
      type: 'lowercase'
    },
    {
      id: 9,
      name: 'E WITH ACUTE, LOWERCASE',
      unicode: 'U+00E9',
      symbol: '&eacute;',
      char: 'é',
      type: 'lowercase'
    },
    {
      id: 10,
      name: 'I WITH ACUTE, LOWERCASE',
      unicode: 'U+00ED',
      symbol: '&iacute;',
      char: 'í',
      type: 'lowercase'
    },
    {
      id: 11,
      name: 'O WITH ACUTE, LOWERCASE',
      unicode: 'U+00F3',
      symbol: '&oacute;',
      char: 'ó',
      type: 'lowercase'
    },
    {
      id: 12,
      name: 'U WITH ACUTE, LOWERCASE',
      unicode: 'U+00FA',
      symbol: '&uacute;',
      char: 'ú',
      type: 'lowercase'
    },
    {
      id: 13,
      name: 'U WITH DIAERESIS, LOWERCASE',
      unicode: 'U+00FC',
      symbol: '&uuml;',
      char: 'ü',
      type: 'lowercase'
    },
    {
      id: 14,
      name: 'N WITH TILDE, LOWERCASE',
      unicode: 'U+00F1',
      symbol: '&ntilde;',
      char: 'ñ',
      type: 'lowercase'
    },
    /////
    {
      id: 15,
      name: 'INVERTED EXCLAMATION MARK',
      unicode: 'U+00A1',
      symbol: '&iexcl;',
      char: '¡',
      type: 'uppercase'
    },
    {
      id: 16,
      name: 'INVERTED QUESTION MARK',
      unicode: 'U+00BF',
      symbol: '&iquest;',
      char: '¿',
      type: 'uppercase'
    }
  ];


  return specialChars;
}